export enum UAPIAutoplayMode {
  AUTOPLAY = 'ap',
  NON_AUTOPLAY = 'nap',
}

export const MOVIE_AUTOPLAY_NUMBER = 10;
export const SERIES_AUTOPLAY_NUMBER = 1;
